import AttorneyTab from "../../../../patient/details/attorney/AttorneyTab";

export default function AttorneyDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}> 
        <AttorneyTab inWorkQ={inWorkQ} />
    </div>
}
